// extracted by mini-css-extract-plugin
export var content = "HeroComponent-module--content--a9b26";
export var featuredImage = "HeroComponent-module--featuredImage--ad1c6";
export var image = "HeroComponent-module--image--ea22f";
export var root = "HeroComponent-module--root--de71f";